/**
 * MyCars login form events. Monitors "login" and "forgot password"
 * form submit clicks. MyCars logins forms (except Registration) is
 * tracked separately than other forms since they are
 * non-lead-generating forms. MyCars registration form grandfathered in
 * to standard form tracking events.
 */

export const DDC_LINK_MYCARSLOGIN = 'ddc.link.mycarsLogin';
export const FORGOT_PASSWORD = 'forgot-password';
export const LOGIN = 'login';

function mycarsLogin({ currentTarget: element }) {
	let eventObject;
	const form = element?.closest?.('.mycars-form');

	if (form) {
		eventObject = {
			eventType: DDC_LINK_MYCARSLOGIN,
			eventData: {
				element,
				text: element?.getAttribute?.('value') || '',
				type:
					form.className.indexOf('forgot-password-form') > -1
						? FORGOT_PASSWORD
						: LOGIN
			}
		};
	}

	return eventObject;
}

export default mycarsLogin;
